import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'
import { Spinner } from 'src/components/spinner'

const Loader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const PaymentsLoading = () => {
  return (
    <Loader>
      <Spinner
        style={{
          color: `${Colors.blueDark}`,
        }}
        size={Shapes.spacing[6]}
      />
    </Loader>
  )
}
